<template>
  <div class="app flex-row align-items-center">
    <div v-if="!userChecking" class="container">

      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-lg-6">
          <div class="card-group mb-0">
            <div class="card p-4 login">
              <div class="loading-wrap" v-show="loading">
                <sync-loader size='15px' color='#20a8d8'></sync-loader>
              </div>

              <div class="card-block">
                
                <div class="login-logo">
                  <img src="/static/img/logo3_color.png">
                </div>
                <h4 class="text-center">{{$t('message.login.title')}}</h4>
                <p class="text-muted text-center title">{{$t('message.login.header')}}</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-user"></i></span>
                  <input v-model="username" type="text" class="form-control" :class="{ 'is-invalid': error.email }" :placeholder="$t('message.login.user_placeholder')">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="icon-lock"></i></span>
                  <input v-model="password" type="password" class="form-control" :class="{ 'is-invalid': error.password }" @keyup.enter="login()" :placeholder="$t('message.login.password_placeholder')">
                </div>
                <div class="row">
                  <div class="col-12" v-if="errorMessage">
                    <p class="text-danger">Error: {{errorMessage}}</p>
                  </div>
                  <div class="col-12">
                    <button type="button" class="btn btn-primary btn-block px-4" @click="login()" >{{$t('message.login.submit')}}</button>
                  </div>
                  <div class="col-12 text-center forgot">
                    <button type="button" class="btn btn-link px-0">{{$t('message.login.forgot_password')}}</button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="false" class="card card-inverse card-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-block text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <button type="button" class="btn btn-primary active mt-3" @click="fetchProfile()">Register Now!</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SyncLoader from 'vue-spinner/src/SyncLoader'
import { dropdown } from 'vue-strap'
import { UserStore } from '@/router'

export default {
  components: {
    SyncLoader,
    dropdown
  },
  data () {
    return {
      username: null,
      password: null,
      userChecking: false,
      errorMessage: null,
      error: {
        email: false,
        password: false
      },
      loading: false
    }
  },
  methods: {
    login (data) {
      this.loading = true
      this.errorMessage = null
      this.$http.post(this.$APP_CONFIG.api.login(), {
        email: this.username,
        password: this.password
      }, {
        withCredentials: true
      })
      .then(res => {
        let success = 200
        if (res.status === success) {
          this.redirect()
        }
      })
      .catch(error => {
        if (error.body.message instanceof Object) {
          var errorMsg = ''
          for (var k in error.body.message) {
            errorMsg += error.body.message[k].join(', ')
          }
          this.errorMessage = errorMsg
        } else {
          this.errorMessage = error.body.message
        }

        this.error.email = error.body.message && error.body.message.email
        this.error.password = error.body.message && error.body.message.password

        this.loading = false
      })
    },
    redirect () {
      let path = this.$guser.redirectPath || '/'
      this.$guser.redirectPath = null

      if (path === '/auth/login' || path === '/') {
        this.$router.replace({path: '/'})
      } else {
        this.$router.replace({path: path})
      }
    },
    changeLang (lang) {
      this.$ls.set('lang', lang)
      this.$i18n.locale = lang
    }
  },
  beforeRouteEnter (to, from, next) {
    // Check user has signed in
    if (UserStore.signedIn()) {
      let path = UserStore.store.user.redirectPath || '/'
      UserStore.store.user.redirectPath = null
      if (path === '/auth/login' || path === '/') {
        next({path: '/'})
      } else {
        next({path: path})
      }
    } else {
      next()
    }
  }
}
</script>

<style lang='scss'>
@import "../../assets/base_container";
.error-message-field {
  color: #f86c6b;
  margin-top: 0.2rem;
}
.login-logo{
  text-align: center;
  img {
    width: 150px;
    padding: 10px;
  }
}
.login{
  h4{
    margin-top: 15px;
  }
  .input-group-addon{
    background-color: #f0f0f0 !important;
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
    border-right: 0 !important;
    border-radius: 5px 0px 0px 5px;
  }
  .form-control{
    border-radius: 0px 5px 5px 0px !important;
  }
  .forgot{
    margin-top: 15px;
  }
  .loading-wrap{
    position: absolute;
    width: 100%;
    z-index: 5;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    left: 0;
    top: 0;
    text-align: center;
    padding-top: 70%;
  }
}

.lang-dd {
  position: absolute;
  margin-top: -25px;
}

.lang-dd-block {
  display: flex;
  justify-content: flex-end;
}

.lang-dd .btn {
  background: transparent !important;
}

</style>



// WEBPACK FOOTER //
// Login.vue?378e9a0e